import script from "./WeekdayPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./WeekdayPicker.vue?vue&type=script&setup=true&lang=js"

import "./WeekdayPicker.vue?vue&type=style&index=0&id=1de2c0d8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1de2c0d8"]])

export default __exports__